export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./packages/element/node_modules/d3-array/src/constant.js
// module id = 103
// module chunks = 0